import { NavigateFunction } from "react-router-dom";

import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";
import { resolveAnchorElement } from "./anchorTargets";
import { NudgeStore } from "./NudgeStore";
import { NudgeAction, NudgeCtaAction } from "./types";

export interface DispatchCtaContext {
  accessJWT: string;
  navigate: NavigateFunction;
  setChatInputText: (v: string) => void;
  traceId: string;
}

export async function dispatchNudgeCta(
  action: NudgeCtaAction,
  ctx: DispatchCtaContext
): Promise<void> {
  switch (action.type) {
    case "url": {
      if (action.url.startsWith("/")) ctx.navigate(action.url);
      else window.open(action.url, "_blank", "noopener,noreferrer");
      return;
    }
    case "tel": {
      window.location.href = `tel:${action.number}`;
      return;
    }
    case "sms": {
      const body = action.body ? `?body=${encodeURIComponent(action.body)}` : "";
      window.location.href = `sms:${action.number}${body}`;
      return;
    }
    case "open_chat": {
      ctx.setChatInputText(action.preset_message ?? "");
      ctx.navigate("/chat");
      return;
    }
    case "server_action": {
      const response = await fetchApi(
        ctx.accessJWT,
        `intent/cta/${ctx.traceId}`,
        API_METHODS.POST,
        { action: action.action, payload: action.payload ?? null }
      );
      const followUp = (response?.data?.nudge ?? response?.nudge) as NudgeAction | undefined;
      if (followUp?.id) NudgeStore.push(followUp);
      return;
    }
    case "anchor": {
      const el = resolveAnchorElement(action.target);
      if (!el) {
        console.warn(`[intent] anchor target not found`, action.target);
        return;
      }
      el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      if (action.expand) {
        window.dispatchEvent(
          new CustomEvent("intent:anchor-expand", { detail: { target: action.target } })
        );
      }
      return;
    }
    default: {
      console.warn(`[intent] unknown cta action.type`, (action as { type?: string }).type);
      return;
    }
  }
}
